const authPersistSelectors = {
    isImpersonated: state => state.authPersist.impersonated,
    isDeveloperMode: state => state.authPersist.developerMode,
}

export default authPersistSelectors
